import {useQuery} from "@tanstack/react-query";
import {
    readDashboardSetting,
    readRevenueByItem,
    readRevenueByTeamByQuarter
} from "../../../../../api/main/DashboardApi";
import {DashboardSettingSearchParamType} from "../interface";

export const useReadRevenueByTeamByQuarter = () => {
    const {data} = useQuery({
        queryKey: ["readRevenueByTeamByQuarter"],
        queryFn: async () => await readRevenueByTeamByQuarter(),
        select: (res) => res?.data.result ?? [],
    });

    return {data};
};
